var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgprogress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1304_89289)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.9951,
    r: 9.5,
    stroke: "#67C8FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10 0.995117C11.3132 0.995117 12.6136 1.25377 13.8268 1.75632C15.0401 2.25887 16.1425 2.99546 17.0711 3.92405C17.9997 4.85263 18.7362 5.95503 19.2388 7.16828C19.7413 8.38154 20 9.6819 20 10.9951H10V0.995117Z",
    fill: "#67C8FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1304_89289"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.995117H20V20.9951H0V0.995117Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgprogress);
export default __webpack_public_path__ + "static/media/imgprogress.1cb1b449067cf3fff34fadf68312fa21.svg";
export { ForwardRef as ReactComponent };